import React from 'react';
import { Button } from '@mui/material';
import { Cancel as CancelIcon } from '@mui/icons-material';
import { useAppSelector, useAppDispatch } from '../../../../app/store';
import { useUpdateRefundMutation } from '../../../../services/RefundService';
import { clearBackupAction as clearBackup } from '../../../../services/RefundService/slice';
import { useNavigate } from 'react-router-dom';

interface CancelButtonProps {
  onError?: (message: string) => void;
}

export const CancelButton: React.FC<CancelButtonProps> = ({ onError }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { currentRefund } = useAppSelector(state => state.refund);
  const [updateRefundMutation, { isLoading }] = useUpdateRefundMutation();

  const isVisible = currentRefund?.status === 'REJECT' || currentRefund?.status === 'STARTED';

  if (!isVisible) return null;

  const handleCancel = async () => {
    if (!currentRefund) return;

    const refundForCancel = {
      ...currentRefund,
      status: 'CANCEL'
    };

    try {
      await updateRefundMutation({ refundView: refundForCancel }).unwrap();
      dispatch(clearBackup());
      navigate(-1);
    } catch (err) {
      onError?.('Failed to cancel refund. Please try again.');
    }
  };

  return (
    <Button
      variant="contained"
      startIcon={<CancelIcon />}
      onClick={handleCancel}
      disabled={isLoading}
      sx={{
        backgroundColor: '#dc2626',
        '&:hover': {
          backgroundColor: '#b91c1c',
        },
        fontWeight: 600
      }}
    >
      {isLoading ? 'Cancelling...' : 'Cancel'}
    </Button>
  );
};
